import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import client from '../api/client';

const emptyForm = {
  category_id: '', organization_id: '', new_organization_name: '', full_name_ar: '', full_name_en: '',
  gender: 'male', date_of_birth: '', nationality: '', national_id: '', passport_no: '', passport_expiry: '',
  job_title: '', email: '', phone: '', emergency_contact_name: '', emergency_contact_phone: '', notes: ''
};

export default function PublicRegister() {
  const { eventId } = useParams();
  const [event, setEvent] = useState(null);
  const [categories, setCategories] = useState([]);
  const [organizations, setOrganizations] = useState([]);
  const [useNewOrg, setUseNewOrg] = useState(false);
  const [form, setForm] = useState(emptyForm);
  const [photo, setPhoto] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    client.get(`/public/events/${eventId}`)
      .then(r => { setEvent(r.data.event); setCategories(r.data.categories); setOrganizations(r.data.organizations); })
      .catch(() => setNotFound(true));
  }, [eventId]);

  const onChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      const fd = new FormData();
      fd.append('event_id', eventId);
      Object.entries(form).forEach(([k, v]) => { if (v !== '') fd.append(k, v); });
      if (photo) fd.append('photo', photo);
      await client.post('/public/register', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      setDone(true);
    } catch (err) {
      setError(err.response?.data?.message || 'حدث خطأ أثناء التسجيل');
    } finally {
      setLoading(false);
    }
  };

  if (notFound) return (
    <div className="login-wrap"><div className="login-card"><div className="login-body">
      <h2 className="login-title">الرابط غير صالح</h2>
      <p className="login-sub">هذه الفعالية غير موجودة أو التسجيل العام مغلق حاليًا.</p>
    </div></div></div>
  );

  if (!event) return <div className="login-wrap"><div className="card">جارٍ التحميل...</div></div>;

  if (done) return (
    <div className="login-wrap"><div className="login-card">
      <div className="login-spectrum" />
      <div className="login-body">
        <h2 className="login-title">تم إرسال طلبك بنجاح ✓</h2>
        <p className="login-sub">تم استلام بيانات تسجيلك في "{event.name_ar}" وسيتم مراجعتها من قبل الجهة المنظمة قريبًا.</p>
      </div>
    </div></div>
  );

  return (
    <div style={{ minHeight: '100vh', background: 'var(--paper)', padding: '30px 16px' }}>
      <div className="card" style={{ maxWidth: 760, margin: '0 auto', borderTop: `4px solid ${event.badge_color || '#0b8793'}` }}>
        <div className="brand-eyebrow" style={{ color: 'var(--signal)' }}>SPORTIX ACCREDITATION</div>
        <h2 style={{ margin: '4px 0 6px' }}>{event.name_ar}</h2>
        <div style={{ color: 'var(--muted)', fontSize: 13, marginBottom: 6 }}>{event.location} · {event.start_date} → {event.end_date}</div>
        {event.description && <p style={{ fontSize: 14, marginBottom: 18 }}>{event.description}</p>}

        {error && <div className="alert alert-error">{error}</div>}

        <form onSubmit={submit}>
          <div className="form-grid">
            <div className="form-field">
              <label>فئة الاعتماد *</label>
              <select name="category_id" value={form.category_id} onChange={onChange} required>
                <option value="">اختر الفئة</option>
                {categories.map(c => <option key={c.id} value={c.id}>{c.name_ar}</option>)}
              </select>
            </div>

            <div className="form-field">
              <label>الجهة / الاتحاد *</label>
              {!useNewOrg ? (
                <select value={form.organization_id} onChange={e => setForm({ ...form, organization_id: e.target.value })} required>
                  <option value="">اختر الجهة</option>
                  {organizations.map(o => <option key={o.id} value={o.id}>{o.name_ar}</option>)}
                </select>
              ) : (
                <input value={form.new_organization_name} onChange={e => setForm({ ...form, new_organization_name: e.target.value })} placeholder="اسم الجهة/الاتحاد" required />
              )}
              <div style={{ marginTop: 6 }}>
                <label style={{ fontSize: 12, cursor: 'pointer' }}>
                  <input type="checkbox" checked={useNewOrg} onChange={e => { setUseNewOrg(e.target.checked); setForm({ ...form, organization_id: '', new_organization_name: '' }); }} />
                  {' '}جهتي غير موجودة في القائمة
                </label>
              </div>
            </div>

            <div className="form-field"><label>الاسم الكامل (عربي) *</label>
              <input name="full_name_ar" value={form.full_name_ar} onChange={onChange} required /></div>
            <div className="form-field"><label>الاسم الكامل (English)</label>
              <input name="full_name_en" value={form.full_name_en} onChange={onChange} /></div>
            <div className="form-field"><label>الجنس *</label>
              <select name="gender" value={form.gender} onChange={onChange} required>
                <option value="male">ذكر</option><option value="female">أنثى</option>
              </select></div>
            <div className="form-field"><label>تاريخ الميلاد</label>
              <input type="date" name="date_of_birth" value={form.date_of_birth} onChange={onChange} /></div>
            <div className="form-field"><label>الجنسية</label>
              <input name="nationality" value={form.nationality} onChange={onChange} /></div>
            <div className="form-field"><label>رقم الهوية الوطنية</label>
              <input name="national_id" value={form.national_id} onChange={onChange} /></div>
            <div className="form-field"><label>رقم جواز السفر</label>
              <input name="passport_no" value={form.passport_no} onChange={onChange} /></div>
            <div className="form-field"><label>الصفة الوظيفية</label>
              <input name="job_title" value={form.job_title} onChange={onChange} placeholder="لاعب، مدرب، حكم..." /></div>
            <div className="form-field"><label>البريد الإلكتروني</label>
              <input type="email" name="email" value={form.email} onChange={onChange} /></div>
            <div className="form-field"><label>رقم الهاتف</label>
              <input name="phone" value={form.phone} onChange={onChange} /></div>
            <div className="form-field"><label>الصورة الشخصية</label>
              <input type="file" accept="image/*" onChange={e => setPhoto(e.target.files[0])} /></div>
          </div>

          <button className="btn btn-primary" style={{ marginTop: 18 }} disabled={loading}>
            {loading ? 'جارٍ الإرسال...' : 'إرسال طلب التسجيل'}
          </button>
        </form>
      </div>
    </div>
  );
}
